import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import appUrls from 'base/app/urls';
import { BUTTON_VARIANTS, TITLE_VARIANTS } from 'common/consts';
import { Arrow } from 'common/icons';
import { Button, Link, Title, Wrapper } from 'common/components';
import {
  ItemsContainer,
  TitleContainer,
  TopBarContainer,
  TopBarContent,
} from 'common/components/TopBar';
import { PK } from 'common/types';
import { composeUrl } from 'common/utils';

export interface TopBarProps {
  pk?: PK;
  title: string;
  disableNav?: boolean;
  children?: React.ReactNode;
}

const ScenarioTopBar = ({ pk, title, disableNav, children }: TopBarProps) => {
  const theme = useTheme();
  const arrowLink = pk
    ? composeUrl(appUrls.SCENARIOS.DETAILS, { params: { pk } })
    : appUrls.SCENARIOS.LIST;

  return (
    <TopBarContainer>
      <TopBarContent>
        <ItemsContainer>
          {!disableNav && (
            <Button variant={BUTTON_VARIANTS.ICON} as={Link} to={arrowLink}>
              <Arrow
                $color={theme.keys.secondaryColor}
                $width="3px"
                $size="12px"
                $margin={[0.5]}
              />
            </Button>
          )}
          <TitleContainer>
            <Link to={arrowLink}>
              <StyledTitle variant={TITLE_VARIANTS.HEADER}>{title}</StyledTitle>
            </Link>
          </TitleContainer>
          <Wrapper margin={[0, 4]}>{children}</Wrapper>
        </ItemsContainer>
      </TopBarContent>
    </TopBarContainer>
  );
};

const StyledTitle = styled(Title)`
  white-space: nowrap;
`;

export default ScenarioTopBar;
